let _focusPopinUids: Record<string, any> = {};

export const setFocusPopinUidMapping = (
  focusPopinUids: Record<string, Record<string, string>>
) => {
  _focusPopinUids = focusPopinUids;
};

export const getFocusPopinUidMapping = (locale: string) =>
  _focusPopinUids[locale] || {};
